/* global BX */
import { defineStore } from 'pinia';
import { toKey } from './composition.js';

export const useFavouritesStore = defineStore('favouritesStore', {
	state: () => ({
		favourites: {},
		count: 0,
	}),
	getters: {
		isInFavourites: (state) => (id) => !!state.favourites[toKey(id)],
	},
	actions: {
		init() {
			this.getFavourites();
		},
		setFavourite(id) {
			const key = toKey(id);
			return BX.ajax.runAction('o2k:sitecore.api.favorites.change', {
				data: {
					productId: key,
				}
			}).then((response) => {
				const { action, cnt } = response.data;
				if (action === 'add')  this.favourites[key] = key;
				if (action === 'delete') delete this.favourites[key];
				this.count = cnt;
			});
		},
		getFavourites() {
			BX.ajax.runAction('o2k:sitecore.api.favorites.get', {
				data: {}
			}).then((response) => {
				const { ids } = response.data;
				this.favourites = ids || {};
				this.count = Object.values(this.favourites).length;
			});
		},
	},
});
